export const HTTP_STATUS = {
  OK: 200,
  NO_CONTENT: 204,
  MULTIPLE_CHOICES: 300,
  UNAUTHORIZED: 401
};
